export default __webpack_public_path__ + "static/media/cartography.4c005d62.png";